(function () {
  function relocatePandaWidgets() {
    // Panda containers look like: <div id="offers-list-container-0" data-cart-button-id="cart-button">
    var pandaContainers = document.querySelectorAll('[id^="offers-list-container-"][data-cart-button-id]');

    pandaContainers.forEach(function (panda) {
      var btnId = panda.getAttribute('data-cart-button-id');
      var cartBtn = btnId ? document.getElementById(btnId) : null;

      // Fallback: try to find the closest submit button in the same product form area
      if (!cartBtn) {
        var nearbyForm = panda.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
        if (nearbyForm) {
          cartBtn = nearbyForm.querySelector('button[type="submit"], input[type="submit"]');
        }
      }

      if (!cartBtn) return;

      // If Panda is already directly after the button, do nothing
      if (cartBtn.nextElementSibling === panda) return;

      // Move Panda directly under Add to Cart
      cartBtn.insertAdjacentElement('afterend', panda);
    });
  }

  function run() {
    relocatePandaWidgets();

    // Observe DOM changes because Panda injects after load
    if (!window.__pandaRelocatorObserver) {
      window.__pandaRelocatorObserver = new MutationObserver(function () {
        relocatePandaWidgets();
      });
      window.__pandaRelocatorObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', run);

  // Shopify theme editor + section reloads
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);

  // Some themes use dynamic navigation
  window.addEventListener('load', run);
})();
